import { injectable } from 'inversify';

import { QuickActionCreateEvent } from '@app/gen/dashboard';

@injectable()
export class QuickActionsMapper {
  processQuickActions(quickActions: QuickActionCreateEvent[]) {
    return quickActions.map(
      ({ company_ids, event_type_ids, side, title, type }) => ({
        companyIds: company_ids || [],
        eventTypeIds: event_type_ids || [],
        side,
        title,
        type,
      }),
    );
  }
}
